import strings from '../../../strings/strings.json';
import { BodySmall, BoldSpan, FlexAlignCenter } from '../../../components/Elements';
import styled from 'styled-components';
import { breakpoints, sizes, theme } from '../../../theme';
import { useElementWidth } from 'hooks/useElementWidth';
import CourseCompleteDate from './CourseCompleteDate';

export default function CourseCardDateSection({
    startDate,
    endDate,
    completedDate,
    cancelled,
    showEndDate = true,
}: {
    startDate: string;
    endDate: string;
    completedDate: Date | null;
    cancelled: boolean;
    showEndDate?: boolean;
}): JSX.Element {
    const [ref, width] = useElementWidth<HTMLDivElement>();

    if (width === undefined) {
        return <DateRow ref={ref} $isNarrow={false} />;
    }

    const isNarrow = width <= 400;

    if (cancelled) return <BodySmallRed $bold>{strings.learnerCourseCard.cancelled}</BodySmallRed>;

    return (
        <DateRow ref={ref} $isNarrow={isNarrow}>
            <DateContainer $isNarrow={isNarrow}>
                <BodySmall>
                    <BoldSpan>{strings.learnerCourseCard.startDate}</BoldSpan> {startDate}
                </BodySmall>
                {showEndDate && (
                    <>
                        {!isNarrow && '-'}
                        <BodySmall>
                            <BoldSpan>{strings.learnerCourseCard.endDate}</BoldSpan> {endDate}
                        </BodySmall>
                    </>
                )}
            </DateContainer>
            {completedDate && <CourseCompleteDate completedDate={completedDate} />}
        </DateRow>
    );
}

const DateRow = styled(FlexAlignCenter)<{ $isNarrow: boolean }>`
    width: 100%;
    justify-content: space-between;
    flex-direction: ${({ $isNarrow }) => ($isNarrow ? 'column' : 'row')};
    align-items: ${({ $isNarrow }) => ($isNarrow ? 'flex-start' : 'center')};
    gap: ${({ $isNarrow }) => ($isNarrow ? sizes.spacingSm : 0)};
`;

const DateContainer = styled.div<{ $isNarrow: boolean }>`
    display: flex;
    justify-content: space-between;
    flex-direction: ${({ $isNarrow }) => ($isNarrow ? 'column' : 'row')};
    align-items: ${({ $isNarrow }) => ($isNarrow ? 'flex-start' : 'center')};
    min-height: ${sizes.spacingRg};
    gap: 8px;

    @media (max-width: ${breakpoints.sm}) {
        flex-direction: column;
        gap: unset;
        align-items: flex-start;
    }
`;

const BodySmallRed = styled(BodySmall)`
    color: ${theme.errorColour};
`;
